import type { paths } from '@orlikfy/api-interfaces';

export type { CreateUserCommentDto, CreateUserCommentResponseDto, UserCommentDto } from '@orlikfy/api-interfaces';

// POST /user-comments
export const CREATE_USER_COMMENT_PATH = '/user-comments' as const satisfies keyof paths;
type CreateUserCommentOperation = paths[typeof CREATE_USER_COMMENT_PATH]['post'];
export type CreateUserCommentBody = CreateUserCommentOperation['requestBody']['content']['application/json'];
export type CreateUserCommentResponse =
  CreateUserCommentOperation['responses']['default']['content']['application/json'];

// GET /user-comments/{userId}
export const GET_USER_COMMENTS_PATH = '/user-comments/{userId}' as const satisfies keyof paths;
type GetUserCommentsOperation = paths[typeof GET_USER_COMMENTS_PATH]['get'];
export type GetUserCommentsPathParams = GetUserCommentsOperation['parameters']['path'];
export type GetUserCommentsResponse = GetUserCommentsOperation['responses']['default']['content']['application/json'];

// DELETE /user-comments/{commentId}
export const REVOKE_USER_COMMENT_PATH = '/user-comments/{commentId}' as const satisfies keyof paths;
type RevokeUserCommentOperation = paths[typeof REVOKE_USER_COMMENT_PATH]['delete'];
export type RevokeUserCommentPathParams = RevokeUserCommentOperation['parameters']['path'];
